/**
 * @file DataViz.js.
 * @author Sérgio Ferraz Souza <todentro@gmail.com>
 * @copyright Cognatis GeoAnalytics & Big Data Ltda :: 2020
 */

import Request from '../components/http/request'
import Service from './Service'

const defaultJsonHeaders = {
  headers: {
    'Content-Type': 'application/json'
  }
}

/**
 * DataViz Management Service
 * @class
 */
class DataViz extends Service {
  constructor (options, resource) {
    super(options)
    this.resource = resource
    // this.request = new Request({environment: 'local', tag: 'das'})
    this.request = new Request({tag: 'das'})
  }
  async InserDataviz (guid, jbData) {
    let model = {
      gdIdParent:guid,
      jbData: jbData,
    }
    return new Promise((resolve, reject) => {
      let endPoint = `/api/0.1-a/ProxyPostgRest/api/tbDataViz`
      this.request.post(endPoint,model, defaultJsonHeaders)
          .then(response => resolve(response))
          .catch(() => reject)
    })
  }
  /**
   * Get layer style
   *
   * @async
   * @function getDefaultStyle
   * @param {string} tag - Tag name
   * @return {Promise<json>} The json with the layer style
   */
  async getDefaultStyle (tag) {
    return new Promise((resolve, reject) => {
      if (typeof tag === 'undefined') reject(new Error('Esperado o identificador da tag'))
      const endPoint = `/api/0.1-a/dataViz/mapbox/style/${tag}`
      this.request.get(endPoint, defaultJsonHeaders)
        .then(response => resolve(response))
        .catch(() => reject)
    })
  }
  /**
   * Get DataViz
   *
   * @async
   * @function getStyle
   * @param {string} layerUid - Layer Uid
   * @return {Promise<json>} The json with the layer
   */
  async getCompositeStyle (layerUid) {
    return new Promise((resolve, reject) => {
      if (typeof layerUid === 'undefined') reject(new Error('Esperado o GUID do layer'))
      let endPoint = `/api/0.1-a/DataViz/mapbox/style/read/${layerUid}`
      this.request.get(endPoint, defaultJsonHeaders)
        .then(response => resolve(response))
        .catch(() => reject)
    })
  }
  /**
   * Get layer style
   *
   * @async
   * @function getStyle
   * @param {string} layer - Layer Uid
   * @param {string} styleType - Style type
   * @return {Promise<json>} The json with the layer style
   */
  async getStyle (layer, styleType) {
    return new Promise((resolve, reject) => {
      if (typeof layer === 'undefined') reject(new Error('Esperado o identificador do layer'))
      if (typeof styleType === 'undefined') reject(new Error('Esperado o identificador do estilo'))
      const endPoint = `/api/0.1-a/dataviz/mapbox/style/${layer}/${styleType}`
      this.request.get(endPoint, defaultJsonHeaders)
        .then(response => resolve(response))
        .catch(() => reject)
    })
  }
  /**
   * Get layer styles
   *
   * @async
   * @function getStyle
   * @param {Number} layerId - Layer Id
   * @return {Promise<json>} The json with the layer style
   */
  async getStyles (layerId) {
    return new Promise((resolve, reject) => {
      if (typeof layerId === 'undefined') reject(new Error('Esperado o identificador do layer'))
      const endPoint = `/api/0.1-a/dataviz/mapbox/styles/${layerId}`
      this.request.get(endPoint, defaultJsonHeaders)
        .then(response => resolve(response))
        .catch(() => reject)
    })
  }
  /**
   * Get style by name
   *
   * @async
   * @function getStyleByName
   * @param {string} name - Style name
   * @return {Promise<json>} The json with the style
   */
  async getStyleByName (name) {
    return new Promise((resolve, reject) => {
      if (typeof name === 'undefined') reject(new Error('Esperado o nome do estilo'))
      const endPoint = `/api/0.1-a/DataViz/mapbox/getstylebyname?name=${name}`
      this.request.get(endPoint, defaultJsonHeaders)
        .then(response => resolve(response))
        .catch(() => reject)
    })
  }
  /**
   * Update custom style for layer
   *
   * @async
   * @function updateCustomStyle
   * @param {string} layer - Layer Uid
   * @param {string} tag - Tag name
   * @param {Object} style - Style definition
   * @return {Promise<json>} The json with the style
   */
  async updateCustomStyle (layer, tag, style) {
    return new Promise((resolve, reject) => {
      if (typeof layer === 'undefined') reject(new Error('Esperado o identificador do layer'))
      if (typeof tag === 'undefined') reject(new Error('Esperado o identificador da tag'))
      if (typeof style === 'undefined') reject(new Error('Esperada definição do estilo'))
      const endPoint = `/api/0.1-a/dataviz/mapbox/style/${layer}/${tag}`
      this.request.patch(endPoint, style, defaultJsonHeaders)
        .then(response => resolve(response))
        .catch(() => reject)
    })
  }
  /**
   * Update custom style for layer
   *
   * @async
   * @function updateCustomStyles
   * @param {array} datalist Lista de Estilos
   * @return {Promise<json>} The json with the style
   */
  async updateCustomStyles (dataList) {
    return new Promise((resolve, reject) => {
      const endPoint = `/api/0.1-a/dataviz/mapbox/styles`
      this.request.patch(endPoint, dataList, defaultJsonHeaders)
          .then(response => resolve(response))
          .catch(() => reject)
    })
  }
}

export { DataViz }
